import type { CrehanaTFunction } from '@crehana/i18n';

export const AMPLITUDE_PAGE_NAME = 'MainHub';
export const PAGE_KEY = 'main-hub';
export const HOME_USER_UNIFIED_WIDGET_SOURCE = 'Home User Unificado';
export const getCardsData = (t: CrehanaTFunction, organizationSlug: string) => {
  return [
    {
      title: t('CARDS_ENROLLED_COURSES_TITLE'),
      description: t('CARDS_ENROLLED_COURSES_DESCRIPTION'),
      cta: t('CARDS_ENROLLED_COURSES_CTA'),
      url: `/org/${organizationSlug}/learn/my-courses/enrolled/`,
      // TODO: Ask Vanessa for an image with less empty space at the right
      image:
        'https://crehana-vercel-images-prd.imgix.net/public/b2b-admin-mf/aa55098e-15a4-4fe2-b2e1-7929a1f72627-frame-34343.png?auto=format&fit=clip',
      hoverClassName:
        'hover:tw-border-solid tw-border-[1px] hover:tw-border-success-400',
    },
    {
      title: t('CARDS_LEARNING_PATHS_TITLE'),
      description: t('CARDS_LEARNING_PATHS_DESCRIPTION'),
      url: `/org/${organizationSlug}/learn/my-courses/tracks/`,
      cta: t('CARDS_LEARNING_PATHS_CTA'),
      image:
        'https://crehana-vercel-images-prd.imgix.net/public/b0afb0d7-5ff0-4f52-9a26-5c4ff461f60a-frame-34329.png?auto=format&fit=clip&dpr=1',
      hoverClassName:
        'hover:tw-border-solid tw-border-[1px] hover:tw-border-warning-400',
    },
  ];
};
